import { render } from "./NewEmsDocumentPage.vue?vue&type=template&id=0008376c&scoped=true&ts=true"
import script from "./NewEmsDocumentPage.vue?vue&type=script&lang=ts"
export * from "./NewEmsDocumentPage.vue?vue&type=script&lang=ts"

import "./NewEmsDocumentPage.vue?vue&type=style&index=0&id=0008376c&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0008376c"]])

export default __exports__